import { render, staticRenderFns } from "./Draft.vue?vue&type=template&id=fe15b870"
import script from "./Draft.vue?vue&type=script&lang=ts"
export * from "./Draft.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports